import * as Yup from "yup";
import valid from "card-validator";

const errors = window.post_template?.checkout_v4_form?.checkout_v4_errors;
const requiredError = errors?.tr_checkout_v4_form_requiredError;
const cardError = errors?.tr_checkout_v4_form_cardError;
const expirationError = errors?.tr_checkout_v4_form_expirationError;
const emailError = errors?.tr_checkout_v4_form_emailError;
const phoneError = errors?.tr_checkout_v4_form_phoneError;
const cvvError = errors?.tr_checkout_v4_form_cvvError;
const policyError = errors?.tr_checkout_v4_form_termsError;

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email(emailError)
    .when("$type", (type, schema) => {
      if (type[0].method == "card" || type[0].paypalHandler == "wr") {
        return schema.required(requiredError);
      }
    }),
  phone: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].paypalHandler == "wr") {
      return schema
        .test("phoneValidTest", phoneError, (value) => {
          const input = document.querySelector(".iti__tel-input");
          const iti = window.intlTelInputGlobals.getInstance(input);

          return iti.isValidNumber();
        })
        .required(requiredError);
    }
  }),

  first_name: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].paypalHandler == "wr") {
      return schema.required(requiredError);
    }
  }),
  last_name: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].paypalHandler == "wr") {
      return schema.required(requiredError);
    }
  }),
  address: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].paypalHandler == "wr") {
      return schema.required(requiredError);
    }
  }),
  country: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].paypalHandler == "wr") {
      return schema.required(requiredError);
    }
  }),
  state: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].paypalHandler == "wr") {
      return schema.required(requiredError);
    }
  }),
  zip: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].paypalHandler == "wr") {
      return schema.required(requiredError);
    }
  }),
  city: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card" || type[0].paypalHandler == "wr") {
      return schema.required(requiredError);
    }
  }),

  card_name: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card") {
      return schema.required(requiredError);
    }
  }),

  card_number: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card") {
      return schema
        .test("test-cardNumb", cardError, (value) => {
          const cardInfo = valid.number(value);
          return cardInfo.isValid || value == "0000 0000 0000 0000";
        })
        .required(requiredError);
    }
  }),

  card_cvc: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card") {
      return schema
        .test("test-cvvNumb", cvvError, (value, schema) => {
          const card_number = schema?.from[0]?.value?.card_number;
          const cvvLength = valid.number(card_number).card?.code?.size;
          return valid.cvv(value, cvvLength).isValid || schema?.from[0]?.value?.card_number == "0000 0000 0000 0000";
        })
        .required(requiredError);
    }
  }),

  card_exp_year: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card") {
      return schema
        .test("test-exp_year", expirationError, (value) => {
          return valid.expirationYear(value).isValid;
        })
        .required(requiredError);
    }
  }),
  card_exp_month: Yup.string().when("$type", (type, schema) => {
    if (type[0].method == "card") {
      return schema
        .test("test-exp_month", expirationError, (value) => {
          return valid.expirationMonth(value).isValid;
        })
        .required(requiredError);
    }
  }),

  policy: Yup.bool().when("$type", (type, schema) => {
    if (type[0].safe === true) {
      return schema.oneOf([true], policyError).required(requiredError);
    }
  }),
});

export { validationSchema };
